import getP13nData from 'services/api/p13n/getP13nData';
import getP13nNbcData from 'services/api/p13n/getP13nNbcData';
import getPreviewP13nData from 'services/api/p13n/getPreviewP13nData';
import getP13nBirthdayData from 'services/api/p13n/getP13nBirthdayData';
import getP13nMABData from 'services/api/p13n/getP13nMABData';
import getP13nReplenData from 'services/api/p13n/getP13nReplenData';
import getP13nRecapABTestData from 'services/api/p13n/getP13nRecapABTestData';
import getP13nPuwylosBatchData from 'services/api/p13n/getP13nPuwylosBatchData';

export default {
    getP13nData,
    getP13nNbcData,
    getPreviewP13nData,
    getP13nBirthdayData,
    getP13nMABData,
    getP13nReplenData,
    getP13nRecapABTestData,
    getP13nPuwylosBatchData
};
